export default __webpack_public_path__ + "static/media/Summary_Purple.06e1267e.svg";